module.exports = __webpack_public_path__ + "img/PurpleCarnation.40762dc9.png";